import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { ArabicHandlerService } from '../../Services/arabicHandler.service';
import { RouterModule } from '@angular/router';
import { INavBar } from './navbar.model';
import { CURRENT_NAVBAR, CURRENT_SYSTEM_LOGOS } from '../../app.config';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule, CommonModule, TranslateModule],
  providers: [TranslateService, TranslatePipe],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent {
  constructor(private translate: TranslateService) {}
  public selectedLanguage: string = localStorage.getItem('language') || 'fr';
  public currentNavBar: INavBar[] = CURRENT_NAVBAR;
  public currentLogos = CURRENT_SYSTEM_LOGOS;

  changeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.selectedLanguage = lang;
    ArabicHandlerService.handleArabicLanguage(lang);
    location.reload();
  }

  toggleDropdown(event: Event) {
    const element = event.currentTarget as HTMLElement;
    const dropdown =
      element.parentElement?.parentElement?.querySelector('.dropdown-menu');
    if (dropdown) {
      const isShown = dropdown.classList.contains('show');
      if (isShown) {
        dropdown.classList.remove('show');
      } else {
        dropdown.classList.add('show');
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const element = event.target as HTMLElement;
    if (!element.closest('.dropdown')) {
      this.closeAllDropdowns();
    }
  }

  closeAllDropdowns() {
    const dropdowns = document.querySelectorAll('.dropdown-menu.show');
    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('show');
    });
  }
}
